/**
 * Local events Bus
 */
import Vue from 'vue'
export default new Vue({
  methods: {
    // vuetify snackbar notifier
    pubNotify: function (data) {
      this.$emit('notify-info', data)
    },
    subNotify: function (func) {
      this.$on('notify-info', func)
    },

    pubError: function (message) {
      this.$emit('notify-error', message)
    },
    subError: function (func) {
      this.$on('notify-error', func)
    },

    // masking loading modal dialog
    mask: function (text) {
      this.$emit('loader-show', text)
    },
    unmask: function () {
      this.$emit('loader-hide')
    },

    subLoaderShow: function (func) {
      this.$on('loader-show', func)
    },
    subLoaderHide: function (func) {
      this.$on('loader-hide', func)
    },

    pubReloadVoicemails: function (vmnew) {
      this.$emit('reload-voicemail', vmnew)
    },
    subReloadVoicemails: function (callback) {
      this.$on('reload-voicemail', callback)
    },

    pubOSIPExch: function (event) {
      this.$emit('opensips-exchange', event)
    },
    subOSIPExch: function (callback) {
      this.$on('opensips-exchange', callback)
    },
    pubDialerCallback: function (event) {
      this.$emit('click_to_dial-send', event)
    },
    subDialerCallback: function (callback) {
      this.$on('click_to_dial-send', callback)
    },
    unsubDialerCallback: function () {
      this.$off('click_to_dial-send')
    }
  }
})
